import Forum from "@material-symbols/svg-500/rounded/forum.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const ForumIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Forum });
	return <Icon />;
};

export default memo(ForumIcon);
